import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import style from './ManageStatisticsItem.style'

const ManageItemStyled = styled.div(props => ({ ...style(props) }))

const ManageStatisticsItem = ({ number, text }) => {
    return (
        <ManageItemStyled>
            {number && (
                <div>
                    <span className="Number">{number}</span>
                    <span>{text}</span>
                </div>
            )}
        </ManageItemStyled>
    )
}

ManageStatisticsItem.propTypes = {
    number: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
}

ManageStatisticsItem.defaultProps = {}

export default withTheme(ManageStatisticsItem)
